<template>
  <v-col>
    <v-row v-if="isAdmin">
      <v-autocomplete
          :items="allCustomers"
          v-model="currentCompany"
          @click:clear="clearCompany"
          clearable
          outlined
          item-text="translatedName"
          item-value="id"
          :disabled="isEdit"
          :label="$t('common:customer')"
      />
    </v-row>
    <v-row>
      <a v-if="!singleSelect" :class="buildingLabelClass" @click="selectAllBuildings">
        {{ $t('buttons:select-all') }}
      </a>
      <v-combobox
          clearable
          :items="restBuilding"
          v-model="buildingList"
          item-value="name"
          item-text="name"
          :multiple="!singleSelect"
          outlined
          :label="$t('common:building')"
      />
    </v-row>
    <v-row>
      <h3 class="facility-label">{{ $t('common:facility_plural') }}</h3>
      <a v-if="!singleSelect" :class="facilityAllSelectClass" @click="selectAllFacilities">
        {{ $t('buttons:select-all') }}
      </a>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-list shaped :class="'facility-list ' + errorClass">
          <v-list-item-group
              v-model="selectedFacilityIds"
              :multiple="!singleSelect"
          >
            <template v-for="(item, i) in facilities">
              <h2
                  v-if="item.buildingName"
                  :key="`divider-${i}-${item.id}`"
              >
                {{item.buildingName}}
              </h2>
              <v-list-item
                  :key="`item-${i}-${item.id}`"
                  :value="item.facilityId"
              >
                <template v-slot:default="{ active }">
                  <v-list-item-content>
                    <v-list-item-title v-text="item.facilityName"></v-list-item-title>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-checkbox
                        :input-value="active"
                    ></v-checkbox>
                  </v-list-item-action>
                </template>
              </v-list-item>
            </template>
          </v-list-item-group>
        </v-list>
        <div class="error--text" v-if="errorClass.length > 0">{{ $t('utils:rules.required') }}</div>
      </v-col>
    </v-row>
  </v-col>
</template>
<script>

import BuildingService from '@/modules/book/services/building-service';
import Utils from '@/modules/core/services/utils';
import DataUtils from '@/modules/core/services/data-utils';
import Building from '@/modules/book/data/building';
import InfoService from '@/modules/core/services/info-service';

export default {
  name: 'FacilityList',
  props: {
    singleSelect: Boolean
  },
  data() {
    return {
      selectedFacilityIds: [],
      initialSelectedFacilityIds: [],
      facilityIdsBeforeBuildingChanged: [],
      currentCompany: {},
      allCustomers: [],
      facilities: [],
      restBuilding: [],
      buildingList: [],
      buildingIds: [],
      isEdit: false,
      errorClass: '',
      changeCompanyFlag: false,
      myShow: false
    }
  },
  watch: {
    buildingIds() {
      this.loadFacilities();
    },
    selectedFacilityIds:{
      deep: true,
      handler() {
        this.errorClass = '';
        this.$emit("facilitiesChange", this.selectedFacilityIds);
      }
    },
    buildingList: {
      deep: true,
      handler() {
        this.facilityIdsBeforeBuildingChanged = this.selectedFacilityIds;
        let buildingIds = [];

        if (!this.singleSelect) {
          this.buildingList.forEach(item => {
            buildingIds.push(item.id);
          })
        } else if (this.buildingList) {
          buildingIds.push(this.buildingList.id);
        }

        this.buildingIds = buildingIds;
      }
    },
    currentCompany() {
      if (!this.changeCompanyFlag) {
        this.buildingList = [];
        this.selectedFacilityIds = [];
      }
      if (this.changeCompanyFlag) this.changeCompanyFlag = false;

      if (this.currentCompany) {
        this.loadBuilding(this.currentCompany);
        this.$emit("companyChange", this.currentCompany);
      }
    }
  },
  computed: {
    isAdmin() {
      return this.$store.getters["auth/isAdmin"];
    },
    isAllBuildingsSelected() {
      return this.restBuilding.length === this.buildingList.length;
    },
    buildingLabelClass() {
      return this.isAllBuildingsSelected ? 'facility-label disable' : 'facility-label';
    },
    isAllFacilitiesSelected() {
      return this.facilities.length === this.selectedFacilityIds.length;
    },
    facilityAllSelectClass() {
      return this.isAllFacilitiesSelected || this.facilities.length === 0 ? 'facility-label disable' : '';
    }
  },
  methods: {
    loadFacilities() {
      this.facilities = [];
      if (!this.buildingIds
          || this.buildingIds.length === 0
          || !this.currentCompany
          || this.currentCompany.length === 0) return;

      BuildingService.getFacilitiesForBuildings(
          this.buildingIds,
          this.currentCompany,
          (response) => {
            this.setFacilities(response.data);
            this.updateSelectedIds();
          },
          () => {
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:facility')}));
          }
      )
    },
    setFacilities(responseData) {
      if (!responseData || responseData.length === 0) {
        return
      }

      let facilities = [];
      let currentBuldingName ='';
      responseData.forEach((building) => {
        building.facilities.forEach((facility) => {
          facilities.push({
            'facilityName': facility.name,
            'facilityId': facility.id,
            'buildingName':  currentBuldingName === building.name ? null :  building.name,
            'buildingId': building.id
          })
          currentBuldingName = building.name;
        });
      });

      this.facilities = facilities;
    },
    loadBuilding(companyId) {
      if (!this.isAdmin) {
        return;
      }
      BuildingService.readAllBuildingByCompanyId(
          companyId,
          (res) => {
            this.restBuilding = DataUtils.parseDataToObjectArray(res.data, Building);
          },
          (error) => {
            this.$logger.error("Error at fetching all buildings: " + error);
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('book/facility:common.building-data')}))
          }
      );
    },
    loadBuildingByLoggedCustomer() {
      BuildingService.readLoggedCustomerFromAPI(
          (res) => {
            this.currentCompany = this.$store.state.auth.profile.customer;
            this.restBuilding = DataUtils.parseDataToObjectArray(res.data, Building);
          },
          (error) => {
            this.$logger.error("Error at fetching all buildings: " + error);
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('book/facility:common.building-data')}))
          }
      );
    },
    setSelectedItems(buildingFacility, item) {
      if (this.isAdmin && item.globalCompany) {
        this.currentCompany = item.globalCompany;
        this.changeCompanyFlag = true;
      }

      this.buildingList = buildingFacility.buildings;
      this.initialSelectedFacilityIds = [];
      this.isEdit = true;
      buildingFacility.facilities.forEach((facility) => {
         this.initialSelectedFacilityIds.push(facility.id);
       });

      if (!this.currentCompany) {
        this.currentCompany = this.$store.state.auth.profile.customer;
        this.changeCompanyFlag = true;
      }
    },
    updateSelectedIds() {
      if (this.initialSelectedFacilityIds && this.initialSelectedFacilityIds.length > 0) {
        this.selectedFacilityIds = this.initialSelectedFacilityIds;
        this.initialSelectedFacilityIds = [];
        return;
      }

      let resultSelectedIds = [];

      this.facilities.forEach((facility) => {
        if (this.facilityIdsBeforeBuildingChanged.indexOf(facility.facilityId) > -1) {
          resultSelectedIds.push(facility.facilityId)
        }
      });
      this.facilityIdsBeforeBuildingChanged = [];
      this.selectedFacilityIds = resultSelectedIds;
    },
    loadCustomers() {
      InfoService.readOptionsByUrl('customer/all-customers',
        (customers) => {
              this.allCustomers = customers;
          },
          (error) => {
            this.$logger.error("Error at fetching all customers: " + error);
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:customer_plural')}));
          }
      )
    },
    clear() {
      this.buildingList = [];
      this.selectedFacilityIds = [];
      this.initialSelectedFacilityIds = [];
      this.currentCompany = this.$store.state.auth.profile.customer;
      this.isEdit = false;
      this.facilityIdsBeforeBuildingChanged = [];
    },
    selectAllBuildings() {
      if (this.isAllBuildingsSelected) return;
      this.buildingList = this.restBuilding;
    },
    selectAllFacilities() {
      if (this.isAllFacilitiesSelected) return;

      let allSelectedFacilities = [];
      this.facilities.forEach(facility => {
        allSelectedFacilities.push(facility.facilityId);
      });

      this.selectedFacilityIds = allSelectedFacilities;
    },
    isMandatoryFilledOut() {
      let result = true;
      this.errorClass = '';

      if (this.selectedFacilityIds.length === 0) {
        result = false;
        this.errorClass = 'border-error';
      }

      return result
    },
    clearCompany() {
      this.facilities = [];
      this.restBuilding = [];
    }
  },
  mounted() {
    if (this.isAdmin) {
      this.loadCustomers();
    }

    this.loadBuildingByLoggedCustomer();
  }
}
</script>

<style lang="scss">
.facility-list {
  height: 415px;
  overflow: auto;

  &.border-error {
    border: 1px solid #ff4081;
  }
}
.facility-label {
  display: block;
  width: 100%;
}
.facility-label.disable {
  color: gray;
}

</style>